import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setLanguage, translate } from 'react-switch-lang';
import 'rsuite/dist/rsuite.min.css';
import Main from 'src/investorSystem/components/main/Main.Investor';
import { RootState } from 'src/redux/config/rootReducer';

function App(): React.ReactElement {
  const { languageContext } = useSelector((state: RootState) => state.general);
  const theme = useSelector((state: RootState) => state.theme);
  const { user } = useSelector((state: RootState) => state.user);
  const history = useHistory();

  /**
   * NOTE this use effect affect all of the theme color
   * this will set all of the variable in the css
   * to use the variables use var(--variable-name)
   */
  useEffect(() => {
    if (!theme) return;
    for (let color in theme.colors) {
      document.getElementById('root').style.setProperty(`--${color}`, theme.colors[color]);
    }

    for (let color in theme.barColors) {
      document.getElementById('root').style.setProperty(`--graph-${color}`, theme.barColors[color]);
    }
    for (let color in theme.pieColors) {
      document.getElementById('root').style.setProperty(`--pie-${color}`, theme.pieColors[color]);
    }
    for (let color in theme.categoryColors) {
      document
        .getElementById('root')
        .style.setProperty(`--category-${color}`, theme.categoryColors[color]);
    }

    for (let font in theme.fonts) {
      document.getElementById('root').style.setProperty(`--${font}`, theme.fonts[font]);
    }
  }, [theme]);

  useEffect(() => {
    if (!user) return;
    if (process.env.REACT_APP_ENV === 'production') initGoogleAnalytics(user);
  }, [user]);

  useEffect(() => {
    setLanguage(languageContext.language);
  }, [languageContext]);

  function initGoogleAnalytics(user) {
    const userId = user.id;
    const { name, email } = user;
    const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
    ReactGA.initialize(trackingId);
    // any data that is relevant to the user session
    // that you would like to track with google analytics
    ReactGA.set({
      userId,
      name,
      email,
    });
    history.listen(location => {
      ReactGA.set({ page: location.pathname }); // Update the user's current page
      ReactGA.pageview(location.pathname); // Record a pageview for the given page
    });
  }

  return <Main />;
}

export default translate(App);
